export default {
    'facility': [
        // {
        //     value: 'PermitNumber',
        //     label: 'Permit Number',
        //     type: 'String'
        // },
        {
            value: 'FacilityID',
            label: 'RBDMS ID',
            type: 'Int',
        },
        {
            value: 'Alias',
            label: 'Sampling Point Alias',
            type: 'String'
        },
        {
            value: 'zzfacility_id_nViro',
            label: 'nViro ID',
            type: 'Int'
        },
    ],
    'project': [
        {
            value: 'APINumber',
            label: 'Facility Number',
            type: 'String'
        },
        {
            value: 'Alias',
            label: 'Facility Alias',
            type: 'String'
        }
    ]
}